<template>
  <v-row>
    <v-col cols="12" fill-height>
      <v-card>
        <v-card-title>
          <h1 class="headline">Service Groups</h1>
          <v-spacer></v-spacer>
        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "itinerary-scenarios"
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/itineraries/scenarios/ItineraryScenarios.vue